import React from 'react'
import FAQs from './components/Faq';
import '../pages/css/Home.css';
import SecOne from '../images/about-banner.png';
import { motion} from "framer-motion";

function Faq() {
  return (
    <><section className="fw-bold text-black">
          <div className="container my-5 container-fluid">
              <div className="row align-items-center">
                  {/* Left Side */}
                  <motion.div
                      className="col-md-6 text-center text-md-start mb-4 mb-md-0"
                      initial={{ x: -100, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.8 }}
                      viewport={{ once: false, amount: 0.2 }}
                  >
                      <h1 className="fw-bold"> <span className="highlight-text">FAQs</span> </h1>
                      <p className="lead fw-bold">
                          Home / <span className="highlight-text">Faq</span>
                      </p>

                  </motion.div>

                  {/* Right Side */}
                  <motion.div
                      className="col-md-6 text-center"
                      initial={{ x: 100, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.8 }}
                      viewport={{ once: false, amount: 0.2 }}
                  >
                      <motion.img
                          src={SecOne}
                          alt="Hero"
                          className="img-fluid rounded"
                          animate={{
                              scale: [1, 1.1, 1],
                          }}
                          transition={{
                              duration: 1.5,
                              repeat: Infinity,
                              repeatType: "loop",
                              ease: "easeInOut",
                          }} />
                  </motion.div>
              </div>
          </div>
      </section>
      <FAQs />
      </>
  )
}

export default Faq